import { Component, AfterContentInit } from '@angular/core';
//import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import * as firebase from 'firebase';
import { MemberService } from './member.service';

import { Member } from './member';
import { Credential } from '../core/credential';

@Component({
  selector: 'member-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./style.css']
})

export class ProfileComponent implements AfterContentInit {
	//profileData: FirebaseObjectObservable<any>;
	memberProfile = new Member();
	warningMsg = {
		'pwMsg':'',
		'chgMsg':'',
		'avatarMsg':''
	}
	credential = new Credential('','');
	newCredential = {
		'oldPW':'',
		'newPW':'',
		'confirmPW':''
	}
	avatar = [0,0,0,0]
	showLoading = true;
	//constructor(public af: AngularFire, private memberService: MemberService) {
	constructor(private memberService: MemberService) {
		
	}

	ngAfterContentInit() {
	    firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.credential.email = user.email;
				this.showLoading = false;
				//this.profileData = this.af.database.object('/profile/'+user.uid);
                //this.profileData.subscribe(
                //   (user) => {
                //       this.memberProfile = user;
                //    }
                //)	
				let db = firebase.database();
			    db.ref('profile/'+user.uid).once('value').then(
					(snapshot:any) => {
						if (snapshot.val()){
							this.memberProfile = snapshot.val();
							if (this.memberProfile.avatar){
								this.avatar = this.memberProfile.avatar
							}
						}
						this.showLoading = false;					
					}
				)
			}
		});
	}

	changeAvatar(part:string, value){
		if (part=='face'){
			this.avatar[0] = value*1;
		} else if (part=='glass'){
			this.avatar[1] = value*1;
		} else if (part=='cloth'){
			this.avatar[2] = value*1;
		} else if (part=='bg'){
			this.avatar[3] = value*1;
		}
	}

	saveAvatar(){
		let user = firebase.auth().currentUser;
		let db = firebase.database();
		if (user){
			db.ref('profile/' + user.uid+'/avatar').set(this.avatar).then(
				result => {
					this.memberService.logAct('addAvatar',user.uid,this.memberProfile.level);
					this.memberService.updateAvatar(this.avatar.slice(0));
					this.warningMsg.avatarMsg = '圖像已更新！';
					setTimeout(()=>{this.warningMsg.avatarMsg = '';},this.memberService.modalDismiss);
				}
			).catch(
				(error:any) => {
					this.warningMsg.chgMsg = error.code;
				}
			);
		}
	}

	saveChange(){
		let user = firebase.auth().currentUser;
		let db = firebase.database();
		if (user){
			db.ref('profile/' + user.uid).set({
			    name: this.memberProfile.name,
			    dateOfBirth: this.memberProfile.dateOfBirth,
			    gender: this.memberProfile.gender,
			    unit: this.memberProfile.unit,
				level:this.memberProfile.level,
				created:this.memberProfile.created?this.memberProfile.created:'',
				createdBy:this.memberProfile.createdBy?this.memberProfile.createdBy:'',
				modified:(new Date()).toString(),
				modifiedBy:user.uid
			}).then(
				result => {
					this.memberService.logAct('updateProfile',user.uid,this.memberProfile.level);
					this.warningMsg.chgMsg = '檔案已更新！';
					setTimeout(()=>{this.warningMsg.chgMsg = '';},this.memberService.modalDismiss);
				}
			).catch(
				(error:any) => {
					this.warningMsg.chgMsg = error.code;
				}
			);
			if (this.credential.email != user.email) {
				//need to update email
				user.updateEmail(this.credential.email).then(
					result => {
						user.sendEmailVerification().then(
		        			r => {
							  this.warningMsg.chgMsg = '確認電郵已發送到所註冊電郵地址。';
							  setTimeout(()=>{this.warningMsg.chgMsg = '';},this.memberService.modalDismiss);
							}
						);
					}
				).catch(
					(error:any) => {
						if (error.code=='auth/invalid-email'){
							this.warningMsg.chgMsg = '輸入的電郵無效。';
							setTimeout(()=>{this.warningMsg.chgMsg = '';},this.memberService.modalDismiss);
						} else if (error.code == 'auth/email-already-in-use'){
							this.warningMsg.chgMsg = '電郵已被使用，請用另外一個電郵註冊。';
							setTimeout(()=>{this.warningMsg.chgMsg = '';},this.memberService.modalDismiss);
						} else if (error.code == 'auth/requires-recent-login'){
							this.warningMsg.chgMsg = '您至少要登入一次才可更改電郵。';
							setTimeout(()=>{this.warningMsg.chgMsg = '';},this.memberService.modalDismiss);
						}
					}
				)
			}
			
		}
	}

	changePW(){
		if (this.newCredential.newPW == '' || this.newCredential.confirmPW == ''){
			this.warningMsg.pwMsg = '請輸入現在的密碼、新密碼和確認新密碼';
			setTimeout(()=>{this.warningMsg.pwMsg = '';},this.memberService.modalDismiss);
			return
		} else if (this.newCredential.newPW != this.newCredential.confirmPW) {
			this.warningMsg.pwMsg = '新密碼和確認新密碼不符';
			setTimeout(()=>{this.warningMsg.pwMsg = '';},this.memberService.modalDismiss);
			return
		} else {
			this.warningMsg.pwMsg = '處理中，請稍候！';
			var user = firebase.auth().currentUser;

			user.updatePassword(this.newCredential.newPW).then(
				result => {
			  		this.warningMsg.pwMsg = '密碼已更新！';
				}
			).catch(
				(error:any) => {
			  	if (error.code == 'auth/requires-recent-login') {
			  		this.warningMsg.pwMsg = '您至少要登入一次才可更改密碼。'
			  		setTimeout(()=>{this.warningMsg.pwMsg = '';},this.memberService.modalDismiss);
			  	} else {
			  		this.warningMsg.pwMsg = error.code;
			  		setTimeout(()=>{this.warningMsg.pwMsg = '';},this.memberService.modalDismiss);
			  	}
			});
		}

	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/profile.component.ts